module.exports = __webpack_public_path__ + "static/fonts/Acumin-RPro.e6b4f4d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Acumin-RPro.woff
// module id = Hdc3
// module chunks = 1